import installPath from './installPath';

const redirectToHome = err => {
  if (err.response.status === 401) {
    window.location = installPath(); // move to redux router
  }
};

export default redirectToHome;
